export default __webpack_public_path__ + "static/media/our-team-member-03.dabd6d70.jpg";